/**
 * Today desktop v2's per-day editable headline (design/screens/
 * today-desktop-v2.md §4.2: "a short user-editable line, distinct from
 * R8.7's curated sentence-of-the-day").
 *
 * CONTRACT GAP, FLAGGED (not silently worked around): the phase spec left
 * "architect's call whether this is its own new field or reuses/extends an
 * existing per-day concept" as an explicit open decision
 * (docs/specs/phase-6-today-desktop-v2.md §7), but no `DomainApi` field,
 * event type, or command exists for it anywhere in `src/contracts` or
 * `src/domain` as delivered to dev-ui this round (confirmed by a full-repo
 * grep for "headline" — zero matches outside this file and its consumer).
 * Since PRD R1 requires "state persists instantly, no save buttons" and this
 * field is explicitly NOT required to gate "Close the day" or feed any
 * reward math, this module ships it as a DEVICE-LOCAL, per-date
 * localStorage value — the same category as `ownerName.ts`/`theme.ts`
 * (never synced, never appended to the event log, never read by any domain
 * query) — so the screen's specified interaction ships without inventing
 * fabricated domain behavior. This is a stopgap: the headline will NOT
 * survive a device change or an export/import round-trip, which a real
 * event-log-backed field would. Flagged to architect/product-manager as a
 * follow-up: promote this to a real `checkin.headline_set`-shaped event
 * (mirroring `NoteSetEvent`'s exact precedent) in a future pass.
 */

const STORAGE_KEY_PREFIX = 'compass:day-headline:';

export function getStoredDayHeadline(date: string): string {
  if (typeof window === 'undefined') return '';
  return window.localStorage?.getItem(STORAGE_KEY_PREFIX + date) ?? '';
}

export function setStoredDayHeadline(date: string, headline: string): void {
  if (typeof window === 'undefined') return;
  const trimmed = headline.trim();
  if (trimmed.length === 0) {
    window.localStorage?.removeItem(STORAGE_KEY_PREFIX + date);
  } else {
    window.localStorage?.setItem(STORAGE_KEY_PREFIX + date, trimmed.slice(0, 120));
  }
}
